export default __webpack_public_path__ + "static/media/Armbands of Black Oblivion.d618a6a4.jpg";